module.exports = __webpack_public_path__ + "static/media/Back.5d021fb8.svg";